import React, { useContext, useEffect } from 'react';
import { Button, Form, Spinner, Table } from 'react-bootstrap';
import { MdFileCopy, MdEditSquare, MdDelete } from 'react-icons/md'
import { Link, useNavigate } from 'react-router-dom';
import Zoom from 'react-medium-image-zoom';

import { get_sliders_data } from '../../../../Controller/actions';
import { NewContext } from '../../../../Context/NewContext';
import PaginationCmp from '../../../../Components/Pagination/PaginationCmp';
import PopOver from '../../../../Components/Popover/PopOver';
import { Header } from '../../../../Components/Header';
import { THead } from '../../../../Components/Table';

import './sliders.css';

export const Sliders = ({ title }) => {
    const navigate = useNavigate();
    const { filterDropdown, currentTableData, setCurrentTableData, currentPage, setCurrentPage, totalPage, setTotalPage, perPage, setPerPage, isLoading, setIsLoading, confirmationModalShow, setConfirmationModalShow, deleteUpdateTag, setDeleteUpdateItem, search, setDeleteUpdateYes, checkedValues, handleCopyData, handleCheckboxChange } = useContext(NewContext);
    const simpleFields = ["Id", "Name", "Preview", "Link", "Country", "Region", "Orientation", "From_Flg", "SliderTag", "Priority"];
    const dropdownFields = ["Active"];
    const totalFields = simpleFields.length + dropdownFields.length + 2;

    let handleSwitch = (e) => {
        setDeleteUpdateYes("updateslider");
        setDeleteUpdateItem({ id: e.target.id, [e.target.name]: !e.target.checked ? false : true });
        setConfirmationModalShow(!confirmationModalShow)
    };

    const getSliderData = async (_currentPage = 1) => {
        setIsLoading(true);
        try {
            const getSliders = await get_sliders_data(_currentPage, perPage, search, filterDropdown);
            if (getSliders) {
                const { status, data, message, currentPage, perPage, totalPage } = getSliders;
                if (status) {
                    // console.log(data);
                    // setSlidersData(data);
                    setCurrentTableData(data);
                    setCurrentPage(currentPage);
                    setPerPage(perPage);
                    setTotalPage(totalPage);
                } else {
                    setCurrentTableData([]);
                }
            }
            setIsLoading(false);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getSliderData(currentPage);
    }, [deleteUpdateTag, search, filterDropdown]);

    useEffect(() => {
        document.title = `Emoji Keyboard | ${title}`
    }, []);

    return (
        <div className='table-main ms-auto p-3'>
            <Header title={`Sliders`} previewLink={`/preview`} addLink={`/sliderform`} deleteUpdateTag={"alldeletesliders"} />
            <Table striped bordered hover responsive>
                <THead
                    simpleFields={simpleFields}
                    dropdownFields={dropdownFields}
                />
                <tbody>
                    {
                        isLoading ?
                            <tr>
                                <td colSpan={totalFields} className='py-5'>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <Spinner animation="border" />
                                    </div>
                                </td>
                            </tr>
                            : currentTableData.length === 0 ?
                                <tr>
                                    <td colSpan={totalFields} className='py-5 bg-light'>
                                        <div className="d-flex justify-content-center align-items-center">
                                            No Data Found
                                        </div>
                                    </td>
                                </tr>
                                : currentTableData.map((_ele, i) => (
                                    <tr key={i} className="align-middle">
                                        <td>
                                            <Form.Check
                                                type={'checkbox'}
                                                id={`slider-${_ele._id}`}
                                                value={`${_ele._id}`}
                                                checked={checkedValues.includes(`${_ele._id}`)}
                                                onChange={() => handleCheckboxChange(`${_ele._id}`)}
                                                className='item-checkbox'
                                            />
                                        </td>
                                        <td>{perPage * (currentPage - 1) + (i + 1)}</td>
                                        <td>{_ele.name ? _ele.name : <span className='text-muted'>None</span>}</td>
                                        <td>
                                            <div className='imgTd position-relative'>
                                                <img className='table-preview_img position-absolute d-block' src={`${_ele.preview ? `${_ele.preview}` : `../../../assets/images/no-image.png`}`} alt={_ele.name} />
                                                <Zoom>
                                                    <img className='table-preview_img d-block' src={`${_ele.preview ? `${_ele.preview}` : `../../../assets/images/no-image.png`}`} alt={_ele.name} />
                                                </Zoom>
                                            </div>
                                        </td>
                                        <td className={`text-truncate pe-4 position-relative`} style={{ maxWidth: "150px" }}>
                                            {
                                                _ele.link ?
                                                    <>
                                                        <Link to={_ele.link} className="text-dark d-inline" target={`_blank`}>{_ele.link}</Link>
                                                        <PopOver placement={"right"} message={<Link to={_ele.link} className="text-dark popover-btn" target={`_blank`}>{_ele.link}</Link>} />
                                                    </> : <span className='text-muted'>None</span>
                                            }
                                        </td>
                                        <td className={`text-truncate pe-4 position-relative`} style={{ maxWidth: "100px" }}>
                                            {
                                                _ele.country && _ele.country?.length !== 0 ?
                                                    <>
                                                        {_ele.country?.map((_theme_ele, key) => key === _ele.country?.length - 1 ? _theme_ele : `${_theme_ele}, `)}
                                                        <PopOver placement={"right"} data={_ele.country} />
                                                    </> : <span className='text-muted'>None</span>
                                            }
                                        </td>
                                        <td className={`text-truncate pe-4 position-relative`} style={{ maxWidth: "100px" }}>
                                            {
                                                _ele.region && _ele.region?.length !== 0 ?
                                                    <>
                                                        {_ele.region?.map((_theme_ele, key) => key === _ele.region?.length - 1 ? _theme_ele : `${_theme_ele}, `)}
                                                        <PopOver placement={"right"} data={_ele.region} />
                                                    </> : <span className='text-muted'>None</span>
                                            }
                                        </td>
                                        <td>{_ele.orientation ? _ele.orientation : <span className='text-muted'>None</span>}</td>
                                        <td>{_ele.from_flg ? _ele.from_flg : <span className='text-muted'>None</span>}</td>
                                        <td>{_ele.sliderTag ? _ele.sliderTag : <span className='text-muted'>None</span>}</td>
                                        <td>{typeof _ele.priority == 'number' ? _ele.priority : <span className='text-muted'>None</span>}</td>
                                        {
                                            ["isActive"].map((_is_ele, i) => (
                                                <td key={i}>
                                                    {/* <Badge bg={_is_ele ? "success" : "danger"} className="fw-normal px-2">
                                                        {_is_ele ? `On` : `Off`}
                                                    </Badge> */}
                                                    <Form.Check type="switch" id={_ele._id} name={_is_ele} onChange={handleSwitch} checked={_ele[_is_ele]} role="button" />
                                                </td>
                                            ))
                                        }
                                        <td>
                                            <div className='d-flex'>
                                                {/* <TooltipCmp placement={`top`} tooltipText={copyText}> */}
                                                <Button className='px-2 me-2' variant="info" onClick={() => handleCopyData(_ele)}>
                                                    <MdFileCopy color='black' size={"18px"} />
                                                </Button>
                                                {/* </TooltipCmp> */}

                                                {/* <TooltipCmp placement={`top`} tooltipText={`Edit`}> */}
                                                <Button className='px-2 me-2' variant="warning" onClick={() => navigate(`/sliderform`, { state: _ele })}>
                                                    <MdEditSquare color='black' size={"18px"} />
                                                </Button>
                                                {/* </TooltipCmp> */}

                                                {/* <TooltipCmp placement={`top`} tooltipText={`Delete`}> */}
                                                <Button className='px-2 me-2' variant="danger" onClick={() => { setDeleteUpdateYes("deleteslider"); setDeleteUpdateItem({ id: _ele._id, name: _ele.name }); setConfirmationModalShow(!confirmationModalShow) }}>
                                                    <MdDelete color='black' size={"18px"} />
                                                </Button>
                                                {/* </TooltipCmp> */}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                    }
                </tbody>
            </Table >
            <div className={`table-pagination d-flex justify-content-center justify-content-xl-end ${currentTableData.length > 0 ? 'd-block' : 'd-none'}`}>
                <PaginationCmp
                    currentPage={currentPage}
                    totalPage={totalPage}
                    getData={getSliderData}
                />
            </div>
        </div >
    )
};

Sliders.defaultProps = {
    title: "Sliders"
};

export default Sliders;